/**
 * Restricción temporal de menú por iderp (sin modificar permisos_puestos del puesto 88).
 * Valeria Monroy Silva (2548): ocultar nómina de equipo y organigramas; conservar MiNomina
 * y Peticion Horas Extras (el puesto 88 sí tiene esa vista).
 */
export const IDERPS_RESTRICCION_NOMINA_RH = [2548]

const PATHS_OCULTAR_NOMINA_RH = [
  'HorasExtraEquipo',
  'ComentariosNomina',
  'EncargadasComisiones',
  'NominaTeachers',
  'CambiosHorarios',
  'AguinaldosSeguimiento',
  'OrganigramaV2',
  'OrganigramaJefe',
]

function quitarPathsDeItems (items, pathsOcultar) {
  if (!Array.isArray(items)) return []

  const resultado = []
  for (const item of items) {
    if (!item) continue

    if (Array.isArray(item.items) && item.items.length) {
      const anidados = quitarPathsDeItems(item.items, pathsOcultar)
      if (anidados.length) {
        resultado.push({ ...item, items: anidados })
      }
      continue
    }

    if (item.path && pathsOcultar.includes(item.path)) continue
    resultado.push(item)
  }

  return resultado
}

export function aplicarRestriccionMenuPorUsuario (menu, iderp) {
  const id = Number(iderp)
  if (!IDERPS_RESTRICCION_NOMINA_RH.includes(id)) {
    return Array.isArray(menu) ? menu : []
  }

  const list = Array.isArray(menu) ? menu : []
  return list
    .map((top) => {
      const items = quitarPathsDeItems(top.items || [], PATHS_OCULTAR_NOMINA_RH)
      if (top.path && PATHS_OCULTAR_NOMINA_RH.includes(top.path)) {
        return items.length ? { ...top, path: null, items } : { ...top, path: null, items }
      }
      return { ...top, items }
    })
    .filter((top) => {
      if (top.path && !PATHS_OCULTAR_NOMINA_RH.includes(top.path)) return true
      return Array.isArray(top.items) && top.items.length > 0
    })
}
